/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import * as emotion from "emotion";
import {BaseComponent, Dialog_Builder, DialogModule, TS_Input} from "@intuitionrobotics/thunderstorm/frontend";
import {generateHex} from "@intuitionrobotics/ts-common";
import {inputTextField} from "@styles/styles";
import {DialogCard} from "../../widget/DialogCard";
import {OnUsersUpdated, UsersModule} from "@modules/UsersModule";
import {DB_User} from "@app/ir-q-app-common/types/care-center/user";

type State = {
	loading: boolean
	password?: string,
}
type Props = {
	existingUser: DB_User;
}

const content = emotion.css(
	{
		boxSizing: "border-box"
	}
);

const body = emotion.css(
	{
		padding: 20,
		width: "100%",
		boxSizing: "border-box"
	}
);

const inputText = emotion.css(
	{
		marginBottom: 15
	}
);

const inputTextLabel = emotion.css(
	{
		marginBottom: 5
	}
);

export class ChangePasswordDialog
	extends BaseComponent<Props, State>
	implements OnUsersUpdated {

	__onUsersUpdated() {
		DialogModule.close();
	}

	public static show(existingUser: DB_User) {
		new Dialog_Builder(
			<ChangePasswordDialog
				existingUser={existingUser}
			/>
		).setAllowIndirectClosing(true)
		 .show();
	}

	constructor(props: Props) {
		super(props);

		this.state = {
			loading: false
		};
	}

	private submit = () => {
		const newPassword = this.state.password;
		if (!newPassword) {
			this.setState({loading: false});
			return;
		}

		UsersModule.changePassword({email: this.props.existingUser.mail, password: newPassword, password_check: newPassword});
	};

	render() {
		return <DialogCard
				showX={true}
				loading={this.state.loading}
				content={
					this.renderAddOrganizationContent()
				}
				saveLabel={`${this.props.existingUser ? "Update" : "Add"} user`}
				cancelLabel={"Cancel"}
				title={`${this.props.existingUser ? "Update" : "Add"} user`}
				onSave={() => {
					this.setState({loading: true}, () => this.submit());
					// Keep dialog open.
					return true;
				}}
				saveEnabled={!!this.state.password?.trim()}
			/>;
	}

	private renderAddOrganizationContent = () => {
		return <div className={`ll_v_l fill ${content}`}>
			{this.renderContent()}
		</div>;
	};

	private renderContent = () => {
		return <div className={`${body} ll_v_c`}>
			<div className={`ll_v_c`}>
				{this.renderFullName()}
				{this.renderEmail()}
				{this.renderPasswordField()}
			</div>
		</div>;
	};

	private renderPasswordField = () => {
		return <div className={`${inputText} ll_v_l`}>
			<div className={inputTextLabel}>
				New Password:
			</div>
			<div>
				<TS_Input<string>
					className={inputTextField}
					id={"user-password"}
					value={this.state.password}
					placeholder={"Password"}
					onChange={(value: string) => this.setState(state => ({password: value}))}
					type={"text"}
					name={generateHex(8)}
					spellCheck={true}/>
			</div>
		</div>;
	};

	private renderFullName = () => {
		return <div style={{alignSelf: "start", marginBottom: 24}}>
				User name: {this.props.existingUser.first} {this.props.existingUser.last}
			</div>
	};
	private renderEmail = () => {
		return <div style={{alignSelf: "start", marginBottom: 24}}>
				User email: {this.props.existingUser.mail}
			</div>
	};
}
